import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { FormField } from 'semantic-ui-react'
import JoditEditor from 'jodit-react'
import { observer } from 'mobx-react'
import Store from '../../stores/Store'
import { runInAction } from 'mobx'

@observer
class FormEditor extends Component {
  static propTypes = {
    store: PropTypes.instanceOf(Store).isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    error: PropTypes.string,
    onChange: PropTypes.func,
    defaultValue: PropTypes.any,
    castValue: PropTypes.func, // could be useful if you want to cast a value entered
    parseValue: PropTypes.func // could be useful if you want to parse value to form value
  }

    config = {
      buttons: ['bold', 'italic', 'underline', 'strikethrough', '|', 'ul', 'ol', '|', 'center', 'left', 'right', 'justify', '|', 'link'],
      uploader: { insertImageAsBase64URI: true },
      removeButtons: ['brush', 'file'],
      showXPathInStatusbar: false,
      showCharsCounter: false,
      showWordsCounter: false,
      toolbarAdaptive: false,
      language: 'fr'
    }

    handleOnChangeInput = (e) => {
      runInAction(() => {
        const { store, castValue, name } = this.props
        const value = castValue ? castValue(e) : e
        store.set(name, value)
        const error = _.get(store.errorMessages, name, undefined)
        if (error) {
          _.unset(store.errorMessages, name)
        }
      })
    }

    render () {
      const { store, defaultValue, name, label, castValue, parseValue, onChange, error, ...props } = this.props
      const value = _.get(store, name, defaultValue || '') || defaultValue || ''
      const valueError = _.get(store.errorMessages, name, undefined)
      return (
        <FormField
          label={label}
          error={valueError || error}
          control={JoditEditor}
          config={this.config}
          value={parseValue ? parseValue(value) : value}
          onChange={onChange || this.handleOnChangeInput}
          {...props}
        />
      )
    }
}
export default FormEditor
